exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.information-page[data-v-9d81b21e]{height:100%}div.content[data-v-9d81b21e]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}", ""]);

// exports
